import { Typography } from 'seagull';
import { ResponsiveModal } from "../../client-flow/components/ResponsiveModal";
import styles from "./PaymentMethodLearnMoreModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Section = props => /*#__PURE__*/_jsxs("div", {
  className: styles.section,
  children: [props.icon, /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Typography, {
      className: styles.sectionTitle,
      children: props.title
    }), /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: props.body
    })]
  })]
});
const MoneySendIcon = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.18 10.16 8.49001 10.96 8.49001H12.84C13.76 8.49001 14.51 9.27001 14.51 10.24M12 7.5V16.5M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2M22 6V2M22 2H18M22 2L17 7",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
const StatusUpIcon = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M6.13 18.15C6.13 18.5642 6.46579 18.9 6.88 18.9C7.29421 18.9 7.63 18.5642 7.63 18.15H6.13ZM7.63 16.08C7.63 15.6658 7.29421 15.33 6.88 15.33C6.46579 15.33 6.13 15.6658 6.13 16.08H7.63ZM11.25 18.15C11.25 18.5642 11.5858 18.9 12 18.9C12.4142 18.9 12.75 18.5642 12.75 18.15H11.25ZM12.75 14.01C12.75 13.5958 12.4142 13.26 12 13.26C11.5858 13.26 11.25 13.5958 11.25 14.01H12.75ZM16.37 18.15C16.37 18.5642 16.7058 18.9 17.12 18.9C17.5342 18.9 17.87 18.5642 17.87 18.15H16.37ZM17.87 11.93C17.87 11.5158 17.5342 11.18 17.12 11.18C16.7058 11.18 16.37 11.5158 16.37 11.93H17.87ZM17.12 5.85L17.87 5.84989L17.8699 5.10001L17.12 5.1L17.12 5.85ZM16.66 6.39L17.2298 6.87762L17.2309 6.87635L16.66 6.39ZM6.69855 11.7023C6.29664 11.8025 6.05207 12.2095 6.15228 12.6115C6.25249 13.0134 6.65954 13.2579 7.06145 13.1577L6.69855 11.7023ZM14.1904 5.09998C13.7762 5.09997 13.4404 5.43576 13.4404 5.84997C13.4404 6.26418 13.7762 6.59997 14.1904 6.59998L14.1904 5.09998ZM16.3704 8.77009C16.3705 9.1843 16.7063 9.52004 17.1205 9.51998C17.5348 9.51992 17.8705 9.18408 17.8704 8.76987L16.3704 8.77009ZM7.63 18.15V16.08H6.13V18.15H7.63ZM12.75 18.15V14.01H11.25V18.15H12.75ZM17.87 18.15V11.93H16.37V18.15H17.87ZM16.5491 5.36365L16.0891 5.90365L17.2309 6.87635L17.6909 6.33635L16.5491 5.36365ZM16.0902 5.90238C13.6419 8.76349 10.3578 10.7899 6.69855 11.7023L7.06145 13.1577C11.0222 12.1701 14.5781 9.97651 17.2298 6.87762L16.0902 5.90238ZM14.1904 6.59998L17.12 6.6L17.12 5.1L14.1904 5.09998L14.1904 6.59998ZM16.37 5.85011L16.3704 8.77009L17.8704 8.76987L17.87 5.84989L16.37 5.85011ZM9 22.75H15V21.25H9V22.75ZM15 22.75C17.574 22.75 19.5709 22.2398 20.9053 20.9053C22.2398 19.5709 22.75 17.574 22.75 15H21.25C21.25 17.426 20.7602 18.9291 19.8447 19.8447C18.9291 20.7602 17.426 21.25 15 21.25V22.75ZM22.75 15V9H21.25V15H22.75ZM22.75 9C22.75 6.42603 22.2398 4.42914 20.9053 3.09467C19.5709 1.7602 17.574 1.25 15 1.25V2.75C17.426 2.75 18.9291 3.2398 19.8447 4.15533C20.7602 5.07086 21.25 6.57397 21.25 9H22.75ZM15 1.25H9V2.75H15V1.25ZM9 1.25C6.42603 1.25 4.42914 1.7602 3.09467 3.09467C1.7602 4.42914 1.25 6.42603 1.25 9H2.75C2.75 6.57397 3.2398 5.07086 4.15533 4.15533C5.07086 3.2398 6.57397 2.75 9 2.75V1.25ZM1.25 9V15H2.75V9H1.25ZM1.25 15C1.25 17.574 1.7602 19.5709 3.09467 20.9053C4.42914 22.2398 6.42603 22.75 9 22.75V21.25C6.57397 21.25 5.07086 20.7602 4.15533 19.8447C3.2398 18.9291 2.75 17.426 2.75 15H1.25Z",
    fill: "currentColor"
  })
});
const SecuritySafeIcon = () => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    d: "M12.0001 12.5001C13.1047 12.5001 14.0001 11.6046 14.0001 10.5001C14.0001 9.39549 13.1047 8.50006 12.0001 8.50006C10.8955 8.50006 10.0001 9.39549 10.0001 10.5001C10.0001 11.6046 10.8955 12.5001 12.0001 12.5001ZM12.0001 12.5001V15.5001M20.9101 11.12C20.9101 16.01 17.3601 20.59 12.5101 21.93C12.1801 22.02 11.8201 22.02 11.4901 21.93C6.64008 20.59 3.09009 16.01 3.09009 11.12V6.73003C3.09009 5.91003 3.7101 4.98004 4.4801 4.67004L10.0501 2.39007C11.3001 1.88007 12.7101 1.88007 13.9601 2.39007L19.5301 4.67004C20.2901 4.98004 20.9201 5.91003 20.9201 6.73003L20.9101 11.12Z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
export default function PaymentMethodLearnMoreModal(props) {
  const {
    dismissModal,
    isDesktop
  } = props;
  return /*#__PURE__*/_jsx(ResponsiveModal, {
    title: "Learn how payments work",
    backTitle: "Back to payment method",
    isDesktop: isDesktop,
    onClose: dismissModal,
    children: /*#__PURE__*/_jsxs("div", {
      "data-testid": "learn-more-modal",
      className: styles.modal,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "With Anchor, payments are transparent and secure. No more duplicate invoices or errors."
      }), /*#__PURE__*/_jsx(Section, {
        icon: /*#__PURE__*/_jsx(MoneySendIcon, {}),
        title: "Hassle-free payments",
        body: "Payment is automatic for preapproved services, just like a subscription. Additional charges require your confirmation."
      }), /*#__PURE__*/_jsx(Section, {
        icon: /*#__PURE__*/_jsx(StatusUpIcon, {}),
        title: "Full transparency, zero surprises",
        body: "Services, pricing, and discounts can all be viewed and approved in one centralized space."
      }), /*#__PURE__*/_jsx(Section, {
        icon: /*#__PURE__*/_jsx(SecuritySafeIcon, {}),
        title: "Your expenses, your control",
        body: "Charges or additions outside the original preapproved work will require your approval before they are processed."
      })]
    })
  });
}